import { Plus, Trash2 } from "lucide-react";
import { Field, NumberInput, FileUploader } from "../common";
import { RETURN_MOTIFS } from "../../lib/labels";

export const emptyReturn = () => ({ motif: "NOT IN 1", motif_other: "", quantity: "1", rank: "", parcel_ref: "", description: "", photos: [] });

export default function ReturnsEditor({ hasReturns, setHasReturns, returns, setReturns }) {
  const setR = (i, patch) => setReturns(returns.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  return (
    <div className="space-y-4">
      <div className="tl-card">
        <h3 className="text-2xl font-bold uppercase mb-3">Avez-vous des retours ?</h3>
        <div className="grid grid-cols-2 gap-2">
          <button type="button" className={`tl-btn ${hasReturns === true ? "tl-btn-dark" : "tl-btn-ghost"}`} onClick={() => { setHasReturns(true); if (!returns.length) setReturns([emptyReturn()]); }} data-testid="has-returns-yes">Oui</button>
          <button type="button" className={`tl-btn ${hasReturns === false ? "tl-btn-dark" : "tl-btn-ghost"}`} onClick={() => setHasReturns(false)} data-testid="has-returns-no">Non</button>
        </div>
      </div>
      {hasReturns && returns.map((r, i) => {
        const damage = r.motif === "DAMAGE";
        const missingPhotos = damage && r.photos.length < Number(r.quantity || 0);
        return (
          <div key={i} className="tl-card space-y-3 tl-fade" data-testid={`return-${i}`}>
            <div className="flex items-center"><span className="font-bold">Retour {i + 1}</span>
              <button type="button" className="ml-auto tl-btn tl-btn-danger tl-btn-sm" onClick={() => setReturns(returns.filter((_, j) => j !== i))} data-testid={`remove-return-${i}`}><Trash2 size={16} /></button>
            </div>
            <Field label="Motif">
              <select className="tl-select" value={r.motif} onChange={(e) => setR(i, { motif: e.target.value })} data-testid={`return-motif-${i}`}>
                {RETURN_MOTIFS.map((m) => <option key={m} value={m}>{m === "AUTRE" ? "AUTRE (à préciser)" : m}</option>)}
              </select>
            </Field>
            {["AUTRE", "REROUTE"].includes(r.motif) && <Field label={r.motif === "REROUTE" ? "REROUTE : préciser (nouvelle adresse, raison…)" : "Préciser le motif"}><input className="tl-input" value={r.motif_other} onChange={(e) => setR(i, { motif_other: e.target.value })} data-testid={`return-motif-other-${i}`} /></Field>}
            <div className="grid grid-cols-2 gap-3">
              <Field label="Quantité de colis"><NumberInput value={r.quantity} onChange={(v) => setR(i, { quantity: v })} testid={`return-quantity-${i}`} /></Field>
              <Field label="Rang du passage"><NumberInput value={r.rank} onChange={(v) => setR(i, { rank: v })} testid={`return-rank-${i}`} /></Field>
            </div>
            <Field label="Référence colis (si disponible)"><input className="tl-input tl-mono" value={r.parcel_ref} onChange={(e) => setR(i, { parcel_ref: e.target.value })} data-testid={`return-parcel-ref-${i}`} /></Field>
            <Field label="Description (si disponible)"><input className="tl-input" value={r.description} onChange={(e) => setR(i, { description: e.target.value })} data-testid={`return-description-${i}`} /></Field>
            <FileUploader kind="retour_photo" accept="image/*" files={r.photos} onChange={(f) => setR(i, { photos: f })}
              label={damage ? "Photos DAMAGE (1 par colis, obligatoire)" : "Photos (facultatif)"} testid={`return-photos-${i}`} />
            {missingPhotos && <p className="text-sm text-red-700" data-testid={`damage-photo-warning-${i}`}>DAMAGE : ajoutez au moins une photo par colis endommagé ({r.photos.length}/{r.quantity}).</p>}
          </div>
        );
      })}
      {hasReturns && (
        <button type="button" className="tl-btn tl-btn-ghost w-full" onClick={() => setReturns([...returns, emptyReturn()])} data-testid="add-return-button"><Plus size={18} /> Ajouter un retour</button>
      )}
    </div>
  );
}
